import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('discardSafeMailingListsOption')(function discardSafeMailingListsOption(state) {
    var optionState = state.optionState;
    optionState.safeMailingLists = null;
}));
//# sourceMappingURL=discardSafeMailingListsOption.js.map